import React from "react"
import {buildClassList} from "../helpers/utilities"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faSearch} from '@fortawesome/free-solid-svg-icons'

const SearchField  = ({id, formID, buttonId, label, btnLabel, placeholder, action, external, className, style}) => {

  const buttonContents = (
      <button id={buttonId} type="submit" className="pt-1 pb-1 px-2">
        <FontAwesomeIcon icon={faSearch} height="1.2em" width="1.2em" className="fill-current text-blue-500" focusable="false"/>
        <span className="sr-only">{btnLabel}</span>
      </button>)

  return (
    <div className={buildClassList("search relative lg:block", className)}>
      <form id={formID} method="GET" action={action} target={external ? "_blank" : "_self"} className="m-0 mt-4 lg:mt-0">
      <label htmlFor={id}>
        <span className="sr-only">{label}</span>
      </label>
      <input 
        id={id}
        type="text" 
        name="search" 
        style={style}
        className="rounded-sm border-0 p-1 pl-2 float-right w-full right-0 pr-8 text-black placeholder-gray-600" 
        placeholder={placeholder}/>
      <div className="absolute top-0 right-0">
        {buttonContents}
      </div>
      </form>
    </div>
  )
}

export default SearchField
